<template>
    <div>
        <div>
            <div class="row">
                <div class="col-md-12 noPadding">

                    <all-addresses @change="addressChange" ref="allAddresses" :user="user" :countries="countries" :addressbook="addressbook"></all-addresses>

                    <!-- <search-address @change="addressChange" ref="searchAddress"></search-address> -->


                    <!-- <multiple-address @change="addressChange" ref="multipleAddress" :user="user" :countries="countries" :addressbook="addressbook"></multiple-address> -->


                    <input class="form-control" type="hidden" id="shippingAddressName" v-model="addressName" placeholder="">

                    <div class="address-data">
                        <div class="billing-data">
                            <input type="hidden" name="billing[company]" :value="user.billing.company">
                            <input type="hidden" name="billing[street]"  :value="user.billing.street">
                            <input type="hidden" name="billing[city]"    :value="user.billing.city">
                            <input type="hidden" name="billing[zip]"     :value="user.billing.zip">
                            <input type="hidden" name="billing[country]" :value="user.billing.country">                            
                        </div>
                        <div class="shipping-data">
                            <input type="hidden" name="newAddress"        :value="newAddress">
                            <input type="hidden" name="shipping[name]"    :value="deliveryAddress.name">
                            <input type="hidden" name="shipping[company]" :value="deliveryAddress.company">
                            <input type="hidden" name="shipping[street]"  :value="deliveryAddress.street">
                            <input type="hidden" name="shipping[city]"    :value="deliveryAddress.city">
                            <input type="hidden" name="shipping[zip]"     :value="deliveryAddress.zip">
                            <input type="hidden" name="shipping[country]" :value="deliveryAddress.country">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {clone} from "lodash";
import AllAddresses from './AllAddresses.vue'
import MultipleAddress from './MultipleAddress.vue'

export default {

    props: {
        user: {
            required: true,
            default: null
        }
    },

    components: {
        AllAddresses,
        MultipleAddress
    },

    data() {
        return {
            addressbook: [],
            shippingSource: 'user',
            address: clone(this.user),
            newAddress: false,
            addressName: '',
            countries: [],
            addressNameClass: {
                'form-group': true,
                'has-error':  false
            }
        }
    },

    methods: {

        addressChange({address, isNew}) {
            if (address.country) {
                address.countryName = this.countries.filter(function( obj ) {
                    return obj.id == address.country;
                });
                address.countryName = address.countryName[0].name;
            }
            this.address = address;
            this.addressName = address.name;
            this.newAddress = isNew;
        },


        validate() {


            let isValid = this.addressName.length != 0 || this.shippingSource === 'multiple';
            this.addressNameClass['has-error'] = this.addressName.length == 0 || this.shippingSource === 'multiple';

            if (!this.$refs.allAddresses.validate()) {
                isValid = false;
            }


            return isValid;
        }

    },

    computed: {

        deliveryAddress() {

            let address = clone(this.address);
                address.name = this.addressName;

            return address;
        },

        addressNameValid() {
            return true;
        }

    },

    created() {
        this.address = clone(this.user);
        this.addressName = this.address.name;
        this.countries = App.countries;
        App.event.listen('countries.loaded', countries => this.countries = countries);
        App.event.listen('shipping.source.changed', ({who}) => { this.shippingSource = who; });

        new Form().get('/api/addressbook/all')
            .then(addressbook => {
                this.addressbook = addressbook;
            });

        App.event.listen('address-added', (address) => {
            this.addressbook.push(address);
        });
        

    },

    watch: {


        deliveryAddress: {
            handler: function() {
                App.event.fire('shipping.changed', this.deliveryAddress);                
            },
            deep: true
        }
    }

}
</script>
